module.exports = __webpack_public_path__ + "img/data.2525bc26.jpeg";